import React from 'react'
import Switch from '@mui/material/Switch';
import styled from '@emotion/styled';

const SwitchButton = ({ onChange, checked }) => {

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
      ))(({ theme }) => ({
        width: 60,
        height: 30,
        padding: 0,
        marginTop: 8,
        borderRadius: 20,
        '& .MuiSwitch-switchBase': {
          padding: 0,
          margin: 2,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(30px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
              backgroundColor: '#055c9d',
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
          },
          '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
          },
          '&.Mui-disabled .MuiSwitch-thumb': {
            color: 'grey',
          },
          '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.3,
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22,
          height: 22,
          marginTop: 2,
          marginLeft: 2,
        },
        
      }));

  return (
    <IOSSwitch sx={{ m: 1 }} onChange={onChange} defaultChecked={checked} />
  )
}

export default SwitchButton